import dotenv from 'dotenv';

dotenv.config();

export const productionConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    depService: `${process.env.VUE_APP_MTN_DEP_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    worldPlayHost: `${process.env.VUE_APP_WORLD_PLAY_HOST}`,
    nodeEnv: `Prod`
}

export const developmentConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    depService: `${process.env.VUE_APP_MTN_DEP_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    worldPlayHost: `${process.env.VUE_APP_WORLD_PLAY_HOST}`,
    nodeEnv: `Dev`
}

export const stagingConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    depService: `${process.env.VUE_APP_MTN_DEP_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    worldPlayHost: `${process.env.VUE_APP_WORLD_PLAY_HOST}`,
    nodeEnv: `Staging`
}

const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost') || base_url.includes('127.0.0.1')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return developmentConfig
    if (environment === 'production') return productionConfig
}
